var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('b-nav-item',{class:_vm.indicatorclass(),on:{"click":function($event){return _vm.goTo(_vm.step.id)}}},[_vm._v(_vm._s(_vm.step.title))])
}
var staticRenderFns = []

export { render, staticRenderFns }